import { MarketHeader } from '@/components/market/market-header';
import { ProjectDetailClient } from '@/components/market/project-detail-client';
import type { MarketShow } from '@/types';

export default function Show({ edition, initialState, projectId }: MarketShow) {
  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-5 p-4 sm:p-6">
      <MarketHeader
        initialData={initialState}
        hackSlug={edition.slug}
        eventLabel={edition.eventLabel}
      />
      <ProjectDetailClient projectId={projectId} initialState={initialState} />
    </div>
  );
}
